import React from "react";
import { makeStyles, withStyles, createStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { updateRecallListFromWeb } from "../redux_store/appState";
import { updateJobHistory, updateJobStatus } from "../redux_store/jobState";
import { useSelector, useDispatch } from "react-redux";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import DoneIcon from "@material-ui/icons/Done";
import Select from "@material-ui/core/Select";
import { Palette } from "../AppConfig";
import { addNewHistoryLine } from "../helper/Helper";

let Lysaght = false;
let Fielders = false;

const useStyles = makeStyles((theme) => ({
    LysaghtRoot: {
        backgroundColor: "#E9EEF6",
        borderRadius: "10px !important",
        color: "#3b64ab",
        height: "20px",
        "& > svg": {
            visibility: "hidden",
            width: "0px",
            height: "0px",
        },
        "& > div > div": {
            visibility: "hidden",
            width: "0px !important",
            height: "0px !important",
            margin: "0px !important",
        },
    },
    FildersRoot: {
        border: "3px solid #5E3CBA",
        backgroundColor: "#eae5f6",
        borderColor: "#5E3CBA",
        color: "#5E3CBA",
    },
    root: {
        borderRadius: "6px",
        textAlign: "center",
        textTransform: "uppercase",
        font: "9pt " + theme.typography.fontFamily,
        padding: "6px 4px 1px 4px",
        margin: "4px 0px",
        width: "fit-content",
        minWidth: "80px",
    },
    selectRoot: {
        "&:hover": { backgroundColor: "#3b64ab" },
    },
    menuItem: {
        font: "10pt " + theme.typography.fontFamily,
    },
    loading: {
        width: "10px !important",
        height: "10px !important",
        display: "block",
        position: "absolute",
        top: "11px",
        right: "-15px",
    },
}));

const statuses = [
    "New",
    "Design",
    "Quoted",
    "Won",
    "Lost",
    "Deposit Received",
    "With Engineer",
    "With Council",
    "Invoiced",
    "Ordered",
    "Delivered",
    "Construction",
    "Complete",
];

const CustomMenuItem = withStyles((theme) =>
    Lysaght
        ? createStyles({
              root: {
                  lineHeight: 0.1,
                  paddingTop: "3px",
                  paddingBottom: "3px",
                  "&$selected": {
                      backgroundColor: Palette.Lysaght.DarkBlue,
                      color: "white",
                  },
              },
              selected: {},
          })
        : createStyles({})
)(MenuItem);

export const normaliseStatus = (status) => {
    if (!status) return "";

    if (status.toLowerCase() === "lead") {
        return "New";
    }

    const normalisedStatus = status.toLowerCase();
    return statuses.find((s) => s.toLowerCase() === normalisedStatus) || status;
};

export default function BSL_StatusChip(props) {
    Lysaght = window.brand === "Lysaght" || props?.disabled;
    Fielders = !Lysaght;

    const classes = useStyles();
    const dispatch = useDispatch();

    const [loading, setLoading] = React.useState(false);
    const [tempValue, setTempValue] = React.useState(null);
    const user = useSelector((state) => state.app.user);
    const business_code = user?.BusinessDetails?.Code;
    const { job_id, history, disabled } = props;
    const status = normaliseStatus(props.status);

    const handleSelected = () =>
        Lysaght && (
            <div style={{ marginRight: "15px", marginTop: "5px", color: "white" }}>
                <DoneIcon />
            </div>
        );

    const MenuItems = (value) =>
        value.map((e) => (
            <CustomMenuItem key={e} value={e} className={classes.menuItem}>
                {handleSelected()}
                {e === "New" ? "Lead" : e}
            </CustomMenuItem>
        ));

    return (
        <FormControl
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <Select
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                value={tempValue ? tempValue : status}
                disabled={disabled || false}
                onChange={(e) => {
                    if (!business_code) return;
                    setLoading(true);
                    setTempValue(e.target.value);

                    let currentJobHistory = { history };
                    if (!currentJobHistory) currentJobHistory = { History: [] };

                    currentJobHistory = addNewHistoryLine({
                        jobState: currentJobHistory,
                        historyLine: { Status: e.target.value },
                    });

                    if (props.newJobState) {
                        let updateState = props.newJobState;
                        updateState.Status = e.target.value;
                        if (!updateState.History) updateState.History = [];
                        updateState.History.push(currentJobHistory[0]);
                        props.setNewJobState(updateState);
                    }

                    dispatch(updateJobHistory({ business_code, job_id, new_history: currentJobHistory }));
                    dispatch(updateJobStatus(business_code, job_id, e.target.value)).then((result) => {
                        if (result === "OK") {
                            dispatch(updateRecallListFromWeb(user.BusinessDetails.Code)).then((result) => {
                                setLoading(false);
                                setTempValue(null);
                            });
                        } else {
                            setLoading(false);
                            setTempValue(null);
                        }
                    });
                }}
                disableUnderline
                className={`${classes.root} ${Fielders && classes.FildersRoot} ${Lysaght && classes.LysaghtRoot}`}
                SelectDisplayProps={{
                    style: Fielders ? { padding: "0px 24px 0px 0px" } : { padding: "0px" },
                }}
                inputProps={Fielders ? { MenuProps: { disableScrollLock: true } } : undefined}
                MenuProps={{
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                    getContentAnchorEl: null,
                }}
            >
                {MenuItems(statuses)}
            </Select>
            {loading && <CircularProgress className={classes.loading} />}
        </FormControl>
    );
}
